import React, { useEffect, useState, useContext } from "react";
import './Contact.css';
import logo from '../../Assest/LogoSingefin.png';
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import { NavLink } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import emailCardContact from '../../Assest/emailCardContact.png'
import arrowImage from '../../Assest/location-1093169_1920.png';  // Ajusta la ruta de acuerdo a la estructura de tu proyecto
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";

function Contact() {

    const urlGetContacts = urlApiServer + "contacts?populate=*"
    const urlPostContacts = urlApiServer + "contactforms"
    const urlGetCompanyInformations = urlApiServer + "company-informations"

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [explains, setExplains] = useState('')
    const [data, setData] = useState([]);
    const [dataCompanyInformation, setDataCompanyInformation] = useState([]);
    const [locationCoordinates, setLocationCoordinates] = useState([10.9771629, -74.8131299]); // Coordenadas iniciales
    const { infoUser } = useContext(LoginContext)

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }

    const arrowIcon = new L.Icon({
        iconUrl: arrowImage,  // Usa la imagen importada
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });

    // Función para obtener coordenadas desde la dirección
    const getCoordinatesFromAddress = async (address) => {
        console.log('Dirección proporcionada: ', address);
        const simplifiedAddress = address.replace('#', '');
        const geocodeUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(simplifiedAddress)}`;

        try {
            const response = await fetch(geocodeUrl);
            if (!response.ok) {
                console.error('Error en la respuesta de la API:', response.statusText);
                return;
            }
            const data = await response.json();
            if (data && data.length > 0) {
                const lat = parseFloat(data[0].lat);
                const lon = parseFloat(data[0].lon);
                if (!isNaN(lat) && !isNaN(lon)) {
                    setLocationCoordinates([lat, lon]);
                } else {
                    console.error('Coordenadas inválidas: ', lat, lon);
                }
            } else {
                console.log('No se encontraron resultados para la dirección proporcionada.');
            }
        } catch (error) {
            console.error("Error al obtener las coordenadas desde la API:", error);
        }
    };



    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetContacts, requestOptions)
                    .then(response => response.json())
                    .then(ContactResponse => {
                        console.log('info del Contact: ', ContactResponse.data);
                        setData(ContactResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();

    }, [urlGetContacts]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetCompanyInformations, requestOptions)
                    .then(response => response.json())
                    .then(companyInformationResponse => {
                        setDataCompanyInformation(companyInformationResponse.data);
                        if (companyInformationResponse.data.length > 0 && companyInformationResponse.data[0].ubicacion) {
                            getCoordinatesFromAddress(companyInformationResponse.data[0].ubicacion);
                        }
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado');
            }

        })();
    }, [urlGetCompanyInformations]);

    function headleNames(e) {
        setName(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headlePhone(e) {
        setPhone(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo email, usa `value`
    }

    function headleExplains(e) {
        setExplains(e.target.value); // Para un input tipo email, usa `value`
    }

    async function postFormContact() {
        const dataPost = JSON.stringify({
            data: {
                nombres: name,
                telefono: phone,
                correo: email,
                mensaje: explains
            }
        });

        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: 'POST',
            headers: registerHeaders,
            body: dataPost,
            redirect: 'follow'
        };

        await fetch(urlPostContacts, requestOptions)
            .then(response => response.json())
            .then(dataPostResponse => {
                console.log('dataPostResponse', dataPostResponse);
            });
    }

    const MapUpdater = ({ locationCoordinates }) => {
        const map = useMap();
        useEffect(() => {
            map.setView(locationCoordinates);
        }, [locationCoordinates, map]);
        return null;
    };

    return (
        <div className="containerContactSection">
            <div className="containerBannerContact">
                <div className="bannerContact">
                    <div
                        className="imageBannerContact"
                        style={{
                            backgroundImage: data.length > 0 && data[0].imagen_portada_contactanos?.[0]?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_contactanos[0].url})`
                                : "url('../../Assest/temporary/bannerContact.png')",
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerContact">
                                {data.length > 0 && data[0].titulo_portada_contactanos ? data[0].titulo_portada_contactanos : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                    {infoUser.isLoged === true ? (
                        <div className="ContainerButton">
                            <div className="ButtonBanner" onClick={loggedInUser}>
                                <p className="titleButtonBanner">VINCULATE</p>
                            </div>
                        </div>
                    ) : (
                        <div className="ContainerButton">
                            <NavLink className="navLinks navLinkLegal" to="/Vinculacion">
                                <div className="ButtonBanner">
                                    <p className="titleButtonBanner">VINCULATE</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>
            <div className="containerInfoContactSection">
                {data.length > 0 && data[0].texto_seccion_contactanos ? (
                    data[0].texto_seccion_contactanos.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoContactSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textInfoContactSection">
                                                {child.text}
                                            </p>
                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textInfoLinkageSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textInfoLinkageSection">...</p>
                )}
            </div>
            <div className="containerFormContactSection">
                <div className="cardInfoContactSection">
                    <p className="titleCardContact">
                        Contactanos
                    </p>
                    <p className="textCardContact">
                        Email: {dataCompanyInformation.length > 0 && dataCompanyInformation[0].correo ? dataCompanyInformation[0].correo : "..."}
                    </p>
                    <p className="textCardContact">
                        Direccion: {dataCompanyInformation.length > 0 && dataCompanyInformation[0].ubicacion ? dataCompanyInformation[0].ubicacion : "..."}
                    </p>
                    <p className="textCardContact">
                        Telefono: {dataCompanyInformation.length > 0 && dataCompanyInformation[0].telefono ? dataCompanyInformation[0].telefono : "..."}
                    </p>
                </div>
                <div className="cardFormnContactSection">
                    <div className="containerInputsContactSection">
                        <img src={emailCardContact} alt="emailCardContact" className="imageEmailCard" />
                        <input
                            type="text"
                            name="names"
                            placeholder="Nombres"
                            value={name}
                            onChange={headleNames}
                            className="inputsContactSection"
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={headleEmail}
                            className="inputsContactSection"
                        />
                        <input
                            type="number"
                            name="phone"
                            placeholder="célular de contacto"
                            value={phone}
                            onChange={headlePhone}
                            className="inputsContactSection"
                        />
                        <textarea
                            name="explains"
                            placeholder="Explica las razónes:"
                            value={explains}
                            onChange={headleExplains}
                            className="TextareaContactSection"
                        />
                    </div>
                    <div className="buttonFormContact" onClick={postFormContact}>
                        <p className="textFormContact">ENVIAR</p>
                    </div>
                </div>
            </div>
            <div className="containerMapContact">
                <MapContainer center={locationCoordinates} zoom={13} style={{ height: '400px', width: '100%' }}>
                    <TileLayer
                        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <MapUpdater locationCoordinates={locationCoordinates} />
                    <Marker position={locationCoordinates} icon={arrowIcon}>
                        <Popup>Oficinas signafin.<br />{dataCompanyInformation.length > 0 && dataCompanyInformation[0].ubicacion ? dataCompanyInformation[0].ubicacion : "..."}</Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
}

export default Contact;
